import SingleDateRangePicker from './SingleDateRangePicker';

export default SingleDateRangePicker;